<template>
  <div id="user-manage-detail">
    <div class="user-manage-detail flex mar-b-10">
      <div class="user-manage-detail__avatar__img">
        <div class="upload-content">
          <div class="upload-content-img ipub-p2 relative">
            <!-- <img :src="`${domain}/${user.icon||'imageFile/icon.svg'}`"
                 alt=""> -->
            <ipub-upload-cropper @change="(e)=>{handleUpload('icon', e)}"
                                 :canWidth="canWidth"
                                 :canHeight="canHeight"
                                 :scales="2"
                                 :imgUrl="params.icon?domain+'/'+params.icon:domain+'/imageFile/icon.svg'" />
          </div>
        </div>
      </div>
      <div class="user-manage-detail__avatar mar-b-20 mar-l-20">
        <div class="ipub-h2 mar-b-12">
          {{title[user.titleCode]}} {{user.firstName}} {{user.lastName}}
          <ipub-icon v-if="type==='manage-employees'"
                     type="iconProfile" />
        </div>
        <div class="ipub-p2 role-arr mar-b-8">
          <div class="flex">
            <div class="ipub-p2 fw-bd"
                 style="width:80px">Roles</div>
            <div style="max-width:700px;flex-wrap:wrap"
                 class="flex">
              <div v-for="item in roleArr"
                   :key="item.id"
                   class="nowrap"
                   style="margin-right:10px">
                {{item.name}}
                <template v-if="item.journals&&item.journals.length"> (
                  <template v-for="(val, num) in item.journals">
                    {{val}}
                    <template v-if="num !== item.journals.length-1"> / </template></template>
                  )</template>
              </div>
            </div>
          </div>
        </div>
        <div class="flex">
          <div style="width:80px"
               class="mar-b-12 ipub-p2 fw-bd">Email</div>
          <div class="ipub-p2">
            {{user.email}}
          </div>
        </div>
        <div class="flex">
          <div style="width:80px"
               class="ipub-p2 fw-bd">Password</div>
          <div class="ipub-p2">
            <font>******</font>
            <a @click="changePwd">
              <ipub-icon class="mar-l-10 link-color"
                         style="font-size:14px"
                         type="iconEditPen" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <ipub-form ref="profile-form"
               :model="params"
               :rules="rules">
      <ipub-row :gutter="20">
        <ipub-col :span="4">
          <ipub-form-item prop="titleCode"
                          label="Title">
            <ipub-select v-model="params.titleCode"
                         placeholder="Title">
              <ipub-select-option v-for="(value, key) in title"
                                  :key="key"
                                  :value="key">
                {{ value }}
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="firstName"
                          label="First Name">
            <ipub-input placeholder="First Name"
                        v-model.trim="params.firstName" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4">
          <ipub-form-item prop="lastName"
                          label="Last Name">
            <ipub-input placeholder="Last Name"
                        v-model.trim="params.lastName" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <ipub-row :gutter="20">
        <ipub-col :span="isReviewer?4:6">
          <ipub-form-item prop="countryCode"
                          label="Country / Territory">
            <ipub-select v-model="params.countryCode"
                         search
                         @search="countrySearch"
                         placeholder="Country / Territory">
              <ipub-select-option v-for="item in countryList"
                                  :value="item.code"
                                  :key="'countryList'+item.code">
                {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="isReviewer?4:6">
          <ipub-form-item prop="City"
                          label="City">
            <ipub-input placeholder="City"
                        v-model.trim="params.city" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="4"
                  v-if="isReviewer">
          <ipub-form-item prop="degreeCode"
                          label="Highest degree">
            <ipub-select v-model="params.degreeCode"
                         placeholder="Highest degree">
              <ipub-select-option v-for="(value, key) in degree"
                                  :key="key"
                                  :value="key">
                {{ value }}
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <!-- <ipub-form-item v-if="showClassification"
                          prop="categoryIdList"
                          label="Personal Classification">
            <ipub-select placeholder="Personal Classification"
                         :options="categoryList"
                         :tree="true"
                         mode="multiple"
                         optionKey="id"
                         v-model="params.categoryIdList" />
          </ipub-form-item> -->

      <ipub-form-item prop="affiliation"
                      label="Affiliations">
        <div slot="label"
             class="ipub-p2 mar-b-10 fw-bd">
          Affiliations
          <font class="key-color">*</font>
          <span class="mar-l-20 link-color ipub-c-p"
                @click="addMore('affiliations')">
            <ipub-icon type="iconAdd" />
            Add Affilications
          </span>
        </div>
        <div v-for="(item, index) in params.affiliations"
             class="mar-b-10"
             :key="'params.affiliations'+index">

          <ipub-input placeholder="Affiliations"
                      suffixIcon="iconClose"
                      @blur="getMore('affiliation')"
                      @iconClick="delMore('affiliations',index)"
                      v-model.trim="params.affiliations[index]" />
        </div>
        <!-- <ipub-button type="primary"
                     icon="iconAdd"
                     @click="addMore('affiliations')"
                     style="width:240px"
                     plain>Add Affilications</ipub-button> -->
      </ipub-form-item>
      <!-- <ipub-form-item prop="affiliation"
                          label="Affiliation">
            <ipub-input placeholder="Affiliation"
                        v-model.trim="params.affiliation" />
          </ipub-form-item> -->

      <!-- <ipub-form-item prop="affiliationAddress"
                          label="Affiliations Address">
            <ipub-input placeholder="Affiliations Address"
                        v-model.trim="params.affiliationAddress" />
          </ipub-form-item> -->
      <ipub-row :gutter="20"
                v-if="isReviewer">
        <ipub-col :span="6">
          <ipub-form-item label="Personal Homepage"
                          prop="website">
            <ipub-input placeholder="Personal Homepage"
                        v-model.trim="params.website" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="cv">
            <div class="ipub-p2 fw-bd mar-b-10 relative"
                 slot="label">
              CV
              <ipub-tooltip placement="right"
                            type="dark"
                            class="mar-l-10">
                <div slot="title">PDF</div>
                <ipub-icon type="iconInfo" />
              </ipub-tooltip>
              <!-- <div class="right-option">
                    <ipub-upload class="ipub-c-p"
                                 @change="(e)=>{handleUpload('cv', e)}">
                      <a class="link-color">Upload</a>
                    </ipub-upload>
                  </div> -->
            </div>
            <ipub-upload-input :file="params"
                               _name="cvName"
                               _path="cv"
                               class="mar-b-20"
                               :domain="domain"
                               @delete="delFile('cv')"
                               @change="(e)=>{handleUpload('cv', e)}" />
            <!-- <div class="ipub-line-block ipub-border relative">
                  <div style="width: calc(100% - 60px)">
                    <a @click="goToPage(`${domain}/${params.cv}`)"
                       v-if="params.cvName">{{params.cvName}}</a>
                    <ipub-upload v-else
                                 class="ipub-c-p"
                                 style="width:100%"
                                 @change="(e)=>{handleUpload('cv', e)}">
                      <a class="line-color">Upload PDF File</a>
                    </ipub-upload>
                  </div>
                  <div class="right-option ipub-p4 flex"
                       v-if="params.cvName"
                       style="right: 10px">
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Replace
                      </div>
                      <ipub-upload v-if="true"
                                   class="line-h-40"
                                   @change="(e)=>{handleUpload('cv', e)}">
                        <a>
                          <ipub-icon style="font-size:16px"
                                     type="iconReplace" />
                        </a>
                      </ipub-upload>
                    </ipub-tooltip>
                    <div style="padding: 0 4px"
                         class="line-color line-h-40">|</div>
                    <ipub-tooltip placement="bottom">
                      <div slot="title">
                        Delete
                      </div>
                      <a class="line-h-40"
                         @click="delFile('cv')">
                        <ipub-icon style="font-size:16px"
                                   type="iconDelete" />
                      </a>
                    </ipub-tooltip>
                  </div>
                </div> -->
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <!-- <ipub-form-item v-if="isReviewer"
                          prop="reviewJournal"
                          label="Reviewed Journal">
            <ipub-input placeholder="Reviewed Journa;"
                        v-model.trim="params.reviewJournal" />
          </ipub-form-item> -->

      <ipub-form-item v-if="isReviewer"
                      prop="reviewJournal"
                      label="Reviewed Journal">
        <div slot="label"
             class="ipub-p2 mar-b-10 fw-bd">
          Reviewed Journal
          <font class="key-color">*</font>
          <span class="mar-l-20 link-color ipub-c-p"
                @click="addMore('reviewJournals')">
            <ipub-icon type="iconAdd" />
            Add Reviewed Journal
          </span>
        </div>
        <div v-for="(item, index) in params.reviewJournals"
             class="mar-b-10"
             :key="'params.reviewJournals'+index">
          <ipub-input placeholder="Reviewed Journal"
                      suffixIcon="iconClose"
                      @blur="getMore('reviewJournal')"
                      @iconClick="delMore('reviewJournals',index)"
                      v-model.trim="params.reviewJournals[index]" />
        </div>
        <!-- <ipub-button type="primary"
                     icon="iconAdd"
                     @click="addMore('reviewJournals')"
                     style="width:240px"
                     plain>Add Reviewed Journal</ipub-button> -->
      </ipub-form-item>

      <ipub-form-item v-if="isReviewer"
                      label="Keyword"
                      prop="keywords">
        <ipub-input placeholder="Keywords can be separated by a semicolon or carriage return"
                    tag
                    v-model="params.keywords" />
      </ipub-form-item>

      <ipub-row :gutter="20"
                v-if="isReviewer">
        <ipub-col :span="6">
          <ipub-form-item prop="journalIdList"
                          label="Journal(s) Would Like to Review">
            <ipub-select v-model="params.journalIdList"
                         placeholder="Choose the journal(s) you would like to review"
                         mode="multiple"
                         :options="journalList" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="frequencyCode"
                          label="Review Frequency">
            <ipub-select v-model="params.frequencyCode"
                         placeholder="Select Review Frequency">
              <ipub-select-option v-for="(value, key) in reviewFrequency"
                                  :key="key"
                                  :value="key">
                {{ value }}
              </ipub-select-option>
            </ipub-select>
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
    </ipub-form>
    <!-- <ipub-button plain
                     type="primary"
                     :style="{ minWidth: '150px' }"
                     @click="cancel">Cancel</ipub-button> -->
    <ipub-button type="primary"
                 :style="{ minWidth: '150px' }"
                 @click="submit">Save & Submit</ipub-button>
    <ChangePwd :isVisable="isVisable"
               @confirm="confirm"
               @cancel="confirm" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
